<glxy-form-field class="mapping-field">
  <input
    matInput
    type="text"
    [placeholder]="'BULK_IMPORT.MAP_FIELDS_STEP.DO_NOT_IMPORT' | translate"
    [attr.aria-label]="'BULK_IMPORT.MAP_FIELDS_STEP.ARIA_LABEL' | translate"
    [formControl]="searchFieldControl"
    [matAutocomplete]="auto"
    (focusout)="revertInvalidSelection()"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event.option.value)">
    @for (group of filteredSchemaGroups$ | async; track group.label) {
      <ng-container>
        <mat-optgroup [label]="group.label">
          @for (option of group.schemaOptions; track option.fieldId) {
            <mat-option [value]="option.fieldId" data-testid="field-option">
              {{ option.fieldName }}
            </mat-option>
          }
        </mat-optgroup>
      </ng-container>
    }
  </mat-autocomplete>
  @if (searchFieldControl.value !== DoNotImportOption) {
    <button
      matSuffix
      [matTooltip]="'BULK_IMPORT.MAP_FIELDS_STEP.DO_NOT_IMPORT' | translate"
      mat-icon-button
      (click)="removeMapping()"
    >
      <mat-icon>clear</mat-icon>
    </button>
  }
</glxy-form-field>
